<template>
    <div>
        <CRow>
            <CCol col="12" xl="12">
                <CCard>
                    <CCardHeader>
                        <strong>جزییات درگاه</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CDataTable hover striped :items="items" :fields="fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }" />
                    </CCardBody>
                    <CCardFooter>
                        <CButton v-show="$store.state.perms.can_update_sms_gateway" color="primary"
                            @click="redirect_to(`/gateway/${$route.params.id}/edit`)">ویرایش</CButton>
                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>
<script>
export default {
    data () {
        return {
            items: [],
        }
    },
    computed: {
        fields(){
            return [
                { key: 'key', label: '', _style: 'width:150px'},
                { key: 'value', label: '', _style: 'width:150px;' }
            ]
        }
    },
    mounted(){
        this.get();
    },
    methods: {
        get() {
            this.axios.get('sms_gateways/'
                        + '?id=' + this.$route.params.id)
                        .then(res => {
                            res.data.map(val => {
                                this.items.push(
                                    {key: 'شناسه', value: val.id},
                                    {key: 'نام درگاه', value: val.name},
                                );
                                switch(val.gateway_type){
                                    case 1:
                                        val.gateway_type = 'گروه آینده مجازی امن';
                                        break;
                                    case 2:
                                        val.gateway_type = 'آتیه داده پرداز - دیتابیس';
                                        break;
                                    case 3:
                                        val.gateway_type = 'رهیاب رایانه گستر';
                                        break;
                                    case 4:
                                        val.gateway_type = 'مرکز گسترش فناوری اطلاعات';
                                        break;
                                    case 5:
                                        val.gateway_type = 'ارمغان راه طلایی';
                                        break;
                                    case 6:
                                        val.gateway_type = 'پیام افزار پیک آسا (021)';
                                        break;
                                    case 7:
                                        val.gateway_type = 'فرهنگ و توسعه کندو';
                                        break;
                                    case 8:
                                        val.gateway_type = 'رهیاب پیام گستران';
                                        break;
                                    case 9:
                                        val.gateway_type = 'پیام افزار پیک آسا (9000)';
                                        break;
                                    case 10:
                                        val.gateway_type = 'راهکار سرزمین هوشمند';
                                        break;
                                    case 11:
                                        val.gateway_type = 'بیتل';
                                        break;
                                    case 12:
                                        val.gateway_type = '12';
                                        break;
                                    case 13:
                                        val.gateway_type = '13';
                                        break;
                                    case 14:
                                        val.gateway_type = '14';
                                        break;
                                }
                                this.items.push(
                                    {key: 'نوع درگاه', value: val.gateway_type},
                                    {key: 'صفحه اول فارسی', value: val.first_page_fa},
                                    {key: 'صفحه دوم فارسی', value: val.second_page_fa},
                                    {key: 'صفحه اول انگلیسی', value: val.first_page_en},
                                    {key: 'صفحه دوم انگلیسی', value: val.second_page_en},
                                );
                                if(val.current_state == true){
                                    val.current_state = 'فعال';
                                } else{
                                    val.current_state = 'غیرفعال';
                                }
                                if(val.is_active == true){
                                    val.is_active = 'فعال';
                                } else{
                                    val.is_active = 'غیرفعال';
                                }
                                this.items.push(
                                    {key: 'وضعیت جاری', value: val.current_state},
                                    {key: 'وضعیت', value: val.is_active},
                                );
                                if(val.temporarily_disable_until != '0001-01-01T00:00:00Z' || value.temporarily_disable_until != ''){
                                    const now = new Date();
                                    const temporarily_disable_until = new Date(value.temporarily_disable_until);
                                    if(temporarily_disable_until >= now){
                                        this.items.push({key: 'temporarily disable until', value: this.$moment(val.temporarily_disable_until, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD')});
                                    }
                                }
                                this.items.push(
                                    {key: 'ping', value: value.ping},
                                    {key: 'موجودی حساب', value: String(val.account_balance).replace(/\B(?=(\d{3})+(?!\d))/g, ",")},
                                    {key: 'تاریخ ایجاد', value: this.$moment(val.created_at, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD')},
                                );
                                if(val.last_activity == '0001-01-01T00:00:00Z'){
                                    this.items.push(
                                        {key: 'آخرین استفاده', value: '---'},
                                    );
                                } else{
                                    this.items.push(
                                        {key: 'آخرین استفاده', value: this.$moment(val.last_activity, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD')},
                                    );
                                }
                            })
                        })
        },
        redirect_to(route) {
            this.$router.push(route);
        },
    },
    beforeCreate() {
        if (this.$store.state.perms.can_view_sms_gateway_page == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
